import { PlanAccountTypes } from "@/types";
import { request } from "./request";

/**
 * Get list of plan accounts
 * @param PlanAccountTypes.PlanAccountResponse
 * @param authToken Authorization token header to be added to make the call
 * @returns Promise<PlanAccountTypes.PlanAccountResponse>
 */

export async function getPlanAccountList(
  data: PlanAccountTypes.PlanAccountPayload,
  authToken: string,
): Promise<PlanAccountTypes.PlanAccountInformation> {
  const response = await request<PlanAccountTypes.PlanAccountInformation>(
    {
      url: "/plan_account/list",
      method: "POST",
      data,
    },
    authToken,
  );

  return response;
}
